import Grid from '@material-ui/core/Grid';
import { ReactComponent as KeyLinksIcon } from 'assets/wg-Key-link.svg';
import { ReactComponent as DerogationsIcon } from 'assets/wg-derogations-link.svg';
import { ReactComponent as SynergiCasesIcon } from 'assets/wg-synergi-cases-link.svg';
import { ReactComponent as WellHealthIcon } from 'assets/wg-well-health.svg';
import { ReactComponent as InterventionsIcon } from 'assets/wg-wir-well-select.svg';
import { ReactComponent as AlertManagementIcon } from 'assets/wg_alerts.svg';
import { PATHS } from 'constants/paths';
import { useIntl } from 'react-intl';
import { generatePath, NavLink } from 'react-router-dom';

import styles from './SidebarContentWellGuardian.module.scss';

const SidebarContentWellGuardian: React.FunctionComponent = () => {
  const intl = useIntl();

  return (
    <Grid direction="column" className={styles.linksContainer} container>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_WELL_HEALTH_HOME)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <WellHealthIcon />
            <Grid item className={styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.wellHealth' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_INTERVENTIONS)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <InterventionsIcon />
            <Grid item className={styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.interventions' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_DEROGATIONS)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <DerogationsIcon />
            <Grid item className={styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.derogations' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_SYNERGI_CASES)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <SynergiCasesIcon />
            <Grid item className={styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.synergiCases' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_KEY_LINK)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <KeyLinksIcon />
            <Grid item className={styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.KeyLinks' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
      <Grid className={styles.categoryLabel} item>
        {intl.formatMessage({ id: 'sidebar.wellGuardian.labels.customization' })}
      </Grid>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.WELL_GUARDIAN_ALERTS_SUBSCRIPTION)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <AlertManagementIcon />
            <Grid item className={styles.linkLabel}>
              {intl.formatMessage({ id: 'sidebar.wellGuardian.routes.alertManagement' })}
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
    </Grid>
  );
};

export default SidebarContentWellGuardian;
